import React, { useEffect, useState } from "react";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import styles from "../styles/global-styles";
import backgroundImage from "../assets/img/header_sites.png";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import ShoppingCartBox from "../components/core/shopping-cart/ShoppingCartBox";
import { AuthService } from "../services/auth.service";
import { actions } from "../redux/actions/alert";

const useStyles = makeStyles(() => ({
  root: { width: "100%" },
  image: {
    maxWidth: "100%",
    width: "100%",
    height: 180,
    minHeight: 130,
    objectFit: "cover",
  },
  nameSite: {
    color: "#1C2668",
    fontWeight: 600,
    position: "absolute",
    top: "180px",
    marginLeft: 40,
  },
  backLink: styles.backLink,
}));

const ContainerShoppingCart = ({
  addAlert,
  detailAlert,
  shoppingCart: { cart },
}) => {
  const classes = useStyles();
  const history = useHistory();

  const [paymentArray, setPaymentArray] = useState([]);

  useEffect(() => {
    const { siteId, id } = AuthService.currentUserValue;
    const paymentArray = [];
    Object.keys(cart).forEach((productId, i) => {
      const body = {
        userId: id,
        siteId,
        productId,
        providerTime:
          Object.values(cart)[i].movile?.provider?.timeGuarantee ||
          Object.values(cart)[i].accesory?.provider?.timeGuarantee ||
          Object.values(cart)[i].chip?.provider?.timeGuarantee ||
          Object.values(cart)[i].cash_card?.card_catalogue?.provider
            ?.timeGuarantee,
      };
      paymentArray.push(body);
    });
    setPaymentArray(paymentArray);

    if (!siteId || !id) {
      setTimeout(() => {
        AuthService.logout();
      }, 25000);
      addAlert({ showAlert: true });
      detailAlert({
        severity: "error",
        message: "Error al recuperar información para procesar la venta",
      });
    }
  }, [Object.keys(cart).length]);

  const handleGoBack = () => {
    console.log("history.goBack()", history);
    history.goBack();
  };

  return (
    <>
      <div className={classes.root}>
        <Typography variant="h4" component="h4" className={classes.nameSite}>
          Mi carrito
        </Typography>
        <Typography variant="body1" component={"div"}>
          <span onClick={() => handleGoBack()} className={classes.backLink}>
            {"<"} Regresar
          </span>
        </Typography>
        <img src={backgroundImage} className={classes.image} alt="" />
      </div>
      {Object.keys(cart).length && paymentArray.length ? (
        <ShoppingCartBox paymentInfo={paymentArray} />
      ) : (
        <Grid container direction="row" justify="center" alignItems="center">
          <Typography
            variant="h5"
            component={"div"}
            style={{ position: "relative", top: 70 }}
          >
            Ups! No has agreado ningún producto al carrito
          </Typography>
        </Grid>
      )}
    </>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

const mapStateToProps = (state) => ({
  shoppingCart: state.shoppingCart,
});

export default connect(mapStateToProps, dispatch)(ContainerShoppingCart);
